import {createSlice} from "@reduxjs/toolkit";

export const notificationMessage = createSlice({
    name:"notificationMessage",
    initialState: {
        showMessage:false,
        message: "",
        notificationStatus: "",
        title:""
    },
    reducers: {
        displayNotification: (state,action) => {
            state.showMessage = true
            state.notificationStatus = action.payload
            state.message = action.payload
            state.title = action.payload
        },
        removeNotification:(state) => {
            state.showMessage = false
        }
    }
})

export const {displayNotification, removeNotification} = notificationMessage.actions
export  default notificationMessage.reducer;